/// <amd-module name="TFS/Diag/ActionsMonitor/ActionMonitorStore" />
export interface IActionRecord {
    actionName: string;
    payload: any;
    stack: string;
    timestamp: Date;
}

export class ActionMonitorStore {
    private _firedActions: IActionRecord[];

    public get firedActions(): IActionRecord[] {
        return this._firedActions;
    }

    constructor(private onChange: () => void) {
        this._firedActions = [];
    }

    public addActionRecord(actionRecord: IActionRecord): void {
        this._firedActions.push(actionRecord);
        this.onChange();
    }

    public clearActionRecord(index: number): void {
        this._firedActions = [...this._firedActions];
        this._firedActions.splice(index, 1);
        this.onChange();
    }

    public clearActionRecords(): void {
        this._firedActions = [];
        this.onChange();
    }
}
